import { addYears } from "date-fns";
import React from "react";
import { useCookies } from "react-cookie";
import Button from "./Button";
import { useLocale } from "./LanguageMenu";

export default function CookieConsent() {
  const [{ cookie_consent }, setCookie] = useCookies(["cookie_consent"]);
  const locale = useLocale();

  if (cookie_consent) return null;

  return (
    <div className="fixed bottom-0 z-[60] flex h-14 w-full items-center justify-between rounded-lg bg-black px-4 text-sm text-white md:left-1/2 md:w-5/6 md:-translate-x-1/2 md:px-6 md:text-base lg:w-1/2">
      <p>
        {locale == "de"
          ? "Wir verwenden cookies, um ihre erfahrung auf unserer website zu verbessern!"
          : "We use cookies to improve your experience on our site!"}
      </p>
      <Button onClick={() => setCookie("cookie_consent", "yes", { expires: addYears(new Date(), 1) })}>OK</Button>
    </div>
  );
}
